// eslint-disable-next-line
// @ts-nocheck
import _, { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import LockResetIcon from '@mui/icons-material/LockReset';
import Tooltip from '@mui/material/Tooltip';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import {
  getLabourDetails,
  getLabourTotalRecords,
  setLabourDetails,
} from '../../store/state/labourSlice';
import {
  useGetAllLabourDetailMutation,
  useDeleteLabourDetailByIdMutation,
} from '../../store/api/labourApi';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined';
import { styled } from '@mui/material/styles';
import { getMessage } from '../../components/message';
import {
  checkPermissions,
  onlyLastEmailShow,
  onlyLastFourNum,
} from '../../sections/@dashboard/parkingspaces/utility';
import { useForgotPasswordMutation } from '../../store/api/userApi';
import { PERMISSION } from '../../utils/userPermission';
import { setUser } from '../../store/state/authSlice';
import { useFindServiceProviderDetailByIdMutation } from '../../store/api/serviceProviderApi';


const authData = JSON.parse(localStorage.getItem('login') || '{}');
const loginDetails = JSON.parse(localStorage.getItem('login') || '{}');
const userType = loginDetails.userType; 
const loggedInServiceProviderId = loginDetails.serviceProviderId;

const TABLE_HEAD = [
  { id: 'name', label: 'Driver Name', alignRight: false },
  { id: 'emailId', label: 'Email Address', alignRight: false },
  { id: 'contactNumber', label: 'Phone Number', alignRight: false },
  { id: 'licenseNumber', label: 'License Number', alignRight: false },
  { id: 'licenseExpiryDate', label: 'License Expiry Date', alignRight: false },
  // { id: 'DownloadAdhar', label: 'Download Aadhar Card ', alignRight: false },
  // { id: 'DownloadContract', label: 'Download Vendor Contract ', alignRight: false },
  ...(userType === 'UTSA'
    ? [{ id: 'vendorName', label: 'Vendor Name', alignRight: false },
      { id: 'vendorCode', label: 'Vendor Code', alignRight: false },
    ]
    : []),
  { id: 'resetPassword', label: 'Reset Password', alignRight: false },
  // { id: ' SendStripeConnectLink', label: ' Send stripe connect link  ', alignRight: false },
  { id: 'DriverStatus', label: "Driver's Status", alignRight: false },
  
];

const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

const MarginBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginTop: '10px',
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {},
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function capitalizeFirstLetter(string) {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function DriverDetails() {
  const navigate = useNavigate();
  const [getAllLabourDetail, labourResponse] = useGetAllLabourDetailMutation();
  const [getAllLabourDetailPending, labourPendingResponse] = useGetAllLabourDetailMutation();
  const [deleteLabourDetail, deleteResponse] = useDeleteLabourDetailByIdMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const labourData = useAppSelector(getLabourDetails);
  const labourTotalRecords = useAppSelector(getLabourTotalRecords);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [driverId, setDriverId] = useState<number>();
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [labourers, setLabourers] =useState([]);
  const [pendingRequestCount, setPendingRequestCount] = useState(0);
  const [forgetPassword, forgetPasswordResponse] = useForgotPasswordMutation();
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - labourers.length) : 0;
  const filteredUsers = labourers;
  const isUserNotFound = filteredUsers.length === 0;
  const [findServiceProviderDetailById,findServiceProviderDetailByIdResponse]=useFindServiceProviderDetailByIdMutation();
  
  // const [serviceProviderId, serviceProviderNewIdResponse] = useSendStripeOnboardEmailMutation();
 
  // console.log(labourers,"labourNewData");

  const [serviceProviderNames, setServiceProviderNames] = useState({});
  const [vendorAlias, setVendorAlias] = useState({});
  
  useEffect(() => {
    const fetchAllServiceProviderNames = async () => {
      const fetchedNames = {}; // Object to hold the results
  
      // Only fetch if filteredUsers and token.token are valid
      if (!filteredUsers || !token.token) return;
  
      const fetchPromises = filteredUsers
        ?.filter((user) => user.serviceProviderId) // Filter users with valid serviceProviderId
        .map(async (user) => {
          const { serviceProviderId } = user;
  
          if (!fetchedNames[serviceProviderId]) {
            try {
              // API call to fetch service provider details
              const findServiceProviderDetailByIdResponse = await findServiceProviderDetailById({
                token: token.token,
                id: serviceProviderId,
              });
  
              // Check if we received a valid name and alias, otherwise default to 'Unknown'
              if (findServiceProviderDetailByIdResponse?.data) {
                fetchedNames[serviceProviderId] = findServiceProviderDetailByIdResponse.data.name || 'Unknown';
                fetchedNames[`${serviceProviderId}_alias`] = findServiceProviderDetailByIdResponse.data.vendorAlias || 'Unknown';
              } else {
                fetchedNames[serviceProviderId] = 'Unknown';
                fetchedNames[`${serviceProviderId}_alias`] = 'Unknown';
              }
            } catch (error) {
              fetchedNames[serviceProviderId] = 'Error';
              fetchedNames[`${serviceProviderId}_alias`] = 'Error';
            }
          }
        });
  
      await Promise.all(fetchPromises);
  
      setServiceProviderNames((prev) => ({ ...prev, ...fetchedNames }));
  
      const fetchedAliases = {};
      Object.keys(fetchedNames).forEach((key) => {
        if (key.endsWith('_alias')) {
          fetchedAliases[key] = fetchedNames[key];
        }
      });
      setVendorAlias((prev) => ({ ...prev, ...fetchedAliases }));
    };
  
    fetchAllServiceProviderNames();
  }, [filteredUsers, token.token]);

  useEffect(() => {
    if (labourData) {
      setLabourers(labourData);
    }
  }, [labourData]);

//  useEffect(() => {
//    getAllLabourDetailPending({
 //     token: token.token,
 //     payload: { offset: rowsPerPage, page: page, orderBy: order, currentStatus: 'Pending' },
//    });
//  }, []);

  useEffect(() => {
    console.log('User Type:', userType);
    console.log('Logged in Service Provider ID:', loggedInServiceProviderId);
    console.log('Token:', token.token);
  
    setFilterName('');
  
    if (userType === 'UTSP') {
      console.log('Fetching labour details for Service Provider ID:', loggedInServiceProviderId);
      getAllLabourDetail({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          orderBy: order,
          currentStatus: 'Approved',
          serviceProviderId: loggedInServiceProviderId, 
        },
      });
    } else if (userType === 'UTSA') {
      console.log('Fetching approved labour details for all service providers');
      getAllLabourDetail({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          orderBy: order,
          currentStatus: 'Approved', 
        },
      });
    }
  }, [userType, loggedInServiceProviderId, page, rowsPerPage, order, token.token, getAllLabourDetail]);


  useEffect(() => {
    if (labourResponse.isSuccess) {
      // console.log(labourResponse.data.data,"labourResponse");
      dispatch(setLabourDetails(labourResponse.data));
    }


    if (labourResponse.isError) {
      let errorData: any = labourResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [labourResponse.isSuccess, labourResponse.isSuccess]);

  useEffect(() => {
    if (labourPendingResponse.isSuccess) {
      setPendingRequestCount(labourPendingResponse.data?.totalRecords);
    }

    if (labourPendingResponse.isError) {
      let errorData: any = labourPendingResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [labourPendingResponse.isSuccess, labourPendingResponse.isSuccess]);

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getAllLabourDetail({
        token: token.token,
        payload: { offset: rowsPerPage, page: page, orderBy: order, currentStatus: 'Approved' },
      });
      toast.success('Driver updated successfully.');
    }

    if (deleteResponse.isError) {
      let errorData: any = deleteResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [deleteResponse.isSuccess, deleteResponse.isError]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = labourers.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllLabourDetail({
      token: token.token,
      payload: { offset: rowsPerPage, page: newPage, currentStatus: 'Approved', orderBy: order },
    });
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllLabourDetail({
      token: token.token,
      payload: { offset: parseInt(event.target.value, 10), page: 0, currentStatus: 'Approved', orderBy: order },
    });
  };

  const handleFilterByName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterName(event.target.value);
      getAllLabourDetail({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          fullName: event.target.value,
          currentStatus: 'Approved',
          orderBy: order,
        },
      });
  };

  const handleDelete = () => {
    setOpen(false);
    deleteLabourDetail({
      id: driverId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  const handleClickChanges = (email: any) => {
    forgetPassword({
      email: email,
      category: 'UTSP',
    });
  };

  const handleClickSendLink = (id: any) => {
    labourId({
      token: token.token,
      labourId: id,
    });
    toast.success('Stripe Connect Link sent successfuly');
  };

  useEffect(() => {
    if (forgetPasswordResponse.isSuccess) {
      toast.success(getMessage.SUCCESS_FORGOT_PASSWORD);
    }

    if (forgetPasswordResponse.isError) {
      toast.error(getMessage.ERROR_FORGOT_PASSWORD);
    }
  }, [forgetPasswordResponse.isSuccess, forgetPasswordResponse.isError]);

  return (
    <Page title="Driver Profile">
      {/* {checkPermissions(PERMISSION.DRIVER_ALL, token.permissions)?( */}
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Driver Profile
          </Typography>
          {checkPermissions(PERMISSION.DRIVER_VIEW, token.permissions) ? null : (
            <ResponsiveBox>
              <Box>
                {/**<Button
                  style={{
                    marginRight: '10px',
                    color: 'white',
                    backgroundColor: '#E23744',
                  }}
                  size="large"
                  variant="contained"
                  onClick={() => {
                    navigate('/dashboard/view-request');
                  }}
                >
                  View Requests ({pendingRequestCount})
                </Button> */}
              </Box>
              <MarginBox>
                {userType !== 'UTSA' && (
                <Button
                  variant="contained"
                  onClick={() => {
                    navigate('/dashboard/add-driver', { state: { editMode: false } });
                  }}
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  size="large"
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                >
                  Add
                </Button>
                )}
              </MarginBox>
            </ResponsiveBox>
          )}
        </Stack>
        <Card>
          <BookingListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName}  placeholder={'Search Driver Name'}/>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={labourers.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
              
              <TableBody>
                {/* console.log(filteredUsers, "Filtered Users")*/} 
                {filteredUsers?.length > 0 ? (
                  filteredUsers.map((row, index) => {
                    // console.log(row, `Row ${index}`); // Log each row during mapping
                    const {
                      id,
                      driverAlias,
                      fullName,
                      serviceProviderId,
                      registeredPhoneNumber,
                      emailId,
                      licExpiryDate,
                      licenseNo,
                      status,
                    } = row;

                    const isItemSelected = selected.indexOf(fullName) !== -1;

                    return (
                      <TableRow
                        hover
                        key={row.id?.toString() || `row-${index}`} // Ensure a valid unique key
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell align="left">
                          <Typography
                            fontWeight="bold"
                            variant="subtitle2"
                            whiteSpace={'nowrap'}
                            style={{
                              color: 'blue',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                             console.log("Navigating to add-driver page with state:", {
                                id: row.id,
                                merchantId: row.merchantId,
                                commission: row.commission,
                                tierType: row.tierType,
                                userId: row.userId,
                                editMode: true,
                              });
                              navigate('/dashboard/add-driver', {
                                state: {
                                  id: id,
                                  merchantId: row.merchantId,
                                  commission: row.commission,
                                  tierType: row.tierType,
                                  userId: row.userId,
                                  editMode: true,
                                },
                              });
                            }}
                          >
                            {capitalizeFirstLetter(driverAlias) || capitalizeFirstLetter(fullName) || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/**  <TableCell align="left">
                          <Typography fontWeight="100" variant="subtitle2">
                            {checkPermissions(PERMISSION.DRIVER_HIDE_DETAIL, token.permissions)
                              ? onlyLastEmailShow(id)
                              : id || 'N/A'}
                          </Typography>
                          </TableCell> */}
                        <TableCell align="left">
                          <Typography fontWeight="100" variant="subtitle2">
                            {checkPermissions(PERMISSION.DRIVER_HIDE_DETAIL, token.permissions)
                              ? onlyLastEmailShow(emailId)
                              : emailId || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontWeight="100" variant="subtitle2">
                            {checkPermissions(PERMISSION.DRIVER_HIDE_DETAIL, token.permissions)
                              ? onlyLastFourNum(registeredPhoneNumber)
                              : registeredPhoneNumber || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                        <Typography fontWeight="100" variant="subtitle2">
                          { licenseNo || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                      <Typography 
                          fontWeight="100" 
                          variant="subtitle2" 
                          style={{
                            color: licExpiryDate && new Date(licExpiryDate) < new Date(new Date().setMonth(new Date().getMonth() + 1)) ? 'red' : 'inherit',
                          }}
                        >
                          {licExpiryDate 
                            ? new Date(licExpiryDate).toLocaleDateString('en-GB') 
                            : 'N/A'}
                        </Typography>
                    </TableCell>
                        {userType === 'UTSA' && (
                          <>
                            <TableCell align="left">
                              <Typography fontWeight="100" variant="subtitle2">
                                {serviceProviderNames[serviceProviderId]
                                  ? capitalizeFirstLetter(serviceProviderNames[serviceProviderId])
                                  : 'Loading...'}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="100" variant="subtitle2">
                                {vendorAlias[`${serviceProviderId}_alias`]
                                  ? capitalizeFirstLetter(vendorAlias[`${serviceProviderId}_alias`])
                                  : 'Loading...'}
                              </Typography>
                            </TableCell>
                          </>
                        )}
                        <TableCell align="center">
                          <Tooltip title="Reset Password">
                            <IconButton
                              onClick={() => handleClickChanges(emailId)}
                              style={{ color: '#E23744' }}
                            >
                              <LockResetIcon/>
                            </IconButton>
                          </Tooltip>
                          
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" justifyContent={'center'}>
                            <Switch
                             // disabled={checkPermissions(PERMISSION.DRIVER_HIDE_DETAIL, token.permissions)} 
                              checked={status}
                              onClick={() => {
                                // console.log("Switch toggled for driver ID:", id);
                                setDriverId(id);
                                handleOpen();
                              }}
                            />
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  console.log("No filtered users available")
                )}
              </TableBody>


                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={labourTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                Are you sure?
              </Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                <Button variant="contained" onClick={cancelDelete} sx={{ margin: '10px' }} style={{color: 'white', backgroundColor: '#E23744'}}>
                  No
                </Button>
                <Button variant="contained" onClick={handleDelete} sx={{ margin: '10px' }} style={{color: 'white', backgroundColor: '#E23744'}}>
                  Yes
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}
        {labourResponse.isLoading || deleteResponse.isLoading ? <Loading /> : null}
      </Container>
      {/* ):null} */}
    </Page>
  );
}
